import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Menu,
  Pagination,
  Table
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Input from '../../components/Forms/Input'
import { inject, observer } from 'mobx-react'
import ClientsStore from '../../stores/ClientsStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import AuthenticationStore from '../../stores/AuthenticationStore'

@inject('clientsStore', 'authenticationStore')
@observer
class ClientsScreen extends Component {
  static propTypes = {
    clientsStore: PropTypes.instanceOf(ClientsStore).isRequired,
    authenticationStore: PropTypes.instanceOf(AuthenticationStore).isRequired
  }

  constructor (props) {
    super(props)
    window.document.title = 'Liste des clients'
  }

  componentDidMount () {
    const { clientsStore } = this.props
    clientsStore.loadAll()
  }

  changePage = (page) => {
    const { clientsStore } = this.props
    clientsStore.changePage(page.activePage)
    clientsStore.loadAll()
  }

  handleSendFilters = () => {
    const { clientsStore } = this.props
    clientsStore.sendFilters()
    clientsStore.loadAll()
  }

  handleClearFilters = () => {
    const { clientsStore } = this.props
    clientsStore.clearFilters()
    clientsStore.loadAll()
  }

  render () {
    const { clientsStore, authenticationStore } = this.props
    const { paging, clients, isLoading } = clientsStore
    return (
      <>
        <Header as='h2'>Liste des clients</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Menu secondary>
          <Menu.Item>
            <Button primary icon as={Link} to='/clients/create'><Icon name='plus' />Ajouter un
              client
            </Button>
          </Menu.Item>
          {authenticationStore.getRoleForControllerAction('clients', ['create']) &&
            <Menu.Item position='right'>
              <Button primary as={Link} to='/clients/synced'>Liste de clients
                ServiCentre
              </Button>
            </Menu.Item>}
        </Menu>

        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as='h3'>Filtrer par:</Header>
              <Form>
                <Form.Group widths='equal'>
                  <Input name='_tmpQuery.PK_Number' label='Code' store={clientsStore} />
                  <Input name='_tmpQuery.name' label='Nom Compagnie' store={clientsStore} />
                  <Input name='_tmpQuery.contact_name' label='Nom Contact' store={clientsStore} />
                  <Input name='_tmpQuery.address' label='Adresse' store={clientsStore} />
                </Form.Group>
                <Button primary onClick={this.handleSendFilters}>Filtrer</Button>
                <Button primary onClick={this.handleClearFilters}>Effacer</Button>
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {paging.Clients && <Pagination
                onPageChange={(e, data) => this.changePage(data)}
                totalPages={paging.Clients.pageCount}
                activePage={paging.Clients.page}
                                 />}
              {!!clients.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Nom Compagnie</Table.HeaderCell>
                      <Table.HeaderCell>Nom Contact</Table.HeaderCell>
                      <Table.HeaderCell>Téléphone</Table.HeaderCell>
                      <Table.HeaderCell>Adresse</Table.HeaderCell>
                      <Table.HeaderCell>Action</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {clients.map(client => {
                      return (
                        <Table.Row key={`client_ ${client.id}`}>
                          <Table.Cell>
                            <Link to={`/clients/view/${client.id}`}>{client.name}</Link>
                          </Table.Cell>
                          <Table.Cell>
                            {client.contact_name}
                          </Table.Cell>
                          <Table.Cell>
                            {client.tel_office}
                          </Table.Cell>
                          <Table.Cell>
                            {client.address.fullAddress}
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={`/clients/view/${client.id}`}><Icon link name='eye' /></Link>
                            <Link to={`/events/create/${client.id}`}><Icon link name='file' /></Link>
                            <Link to={{ pathname: '/events', search: `?clientId=${client.id}` }}><Icon link name='magnify' /></Link>
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default ClientsScreen
